// extracted by mini-css-extract-plugin
module.exports = {"contact":"styles__contact___2k6WQ","title":"styles__title___2MVGL","body":"styles__body___RgLlo","email":"styles__email___3_-m4"};